import { SampleDetailsLink } from "../../../components";
import { classificationByValues } from "../../../lib/enums/ThreatStatusEnum";
import { IAlert } from "../@types";

export type AlertDescriptionSampleLinkProps = {
  data: IAlert;
  linksReloadDocument?: boolean;
  onLinkClick?: () => void;
};

const AlertDescriptionSampleLink = ({
  data,
  linksReloadDocument,
  onLinkClick
}: AlertDescriptionSampleLinkProps) => {
  return (
    <>
      for sample{" "}
      <SampleDetailsLink
        sampleRecord={{
          filename: data.sha1,
          sha1: data.sha1,
          threat_status: data.threat_status,
          classification:
            classificationByValues[data.threat_status].toLowerCase()
        }}
        reloadDocument={linksReloadDocument}
        onClick={onLinkClick}
      />
    </>
  );
};

export default AlertDescriptionSampleLink;
